import { SearchParams } from '@/types'
import {
  CreateFlowSensor,
  InputOptions,
  SensorOptions,
  UpdateFlowSensor,
} from '@/types/hydraulic'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const flowSensorApi = {
  getAll(searchParams: SearchParams) {
    const url = '/api/flowsensor'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: number, id: number) {
    const url = `/api/flowsensor/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateFlowSensor) {
    const url = '/api/flowsensor'
    return axiosClient.post(url, payload)
  },

  delete(interfaceId: string, id: string) {
    const url = `/api/flowsensor/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },

  update(payload: UpdateFlowSensor) {
    const url = '/api/flowsensor'
    return axiosClient.put(url, payload)
  },

  getDetailIO(interfaceId: number): Promise<{ data: InputOptions[] }> {
    const url = `/api/Controller/${interfaceId}/get-details-input`
    return axiosClient.get(url)
  },
  getDetails(interfaceId: number): Promise<{ data: SensorOptions[] }> {
    const url = `api/flowsensor/get-details?interfaceId=${interfaceId}`
    return axiosClient.get(url)
  },
}

export default flowSensorApi
